<script lang="ts">
    import Pagination from 'src/components/cabinet/#common/pagination/Pagination.svelte'
    import Alert from 'src/components/cabinet/#common/alert/Alert.svelte'
    import arrow from 'src/components/main/marketplace/components/nft-cards/arrow.svg'
    import loadMore from 'src/components/main/marketplace/components/nft-cards/load-more.svg'
    import {getItemsByFilter} from 'src/components/cabinet/#services/inventory'
    import {clickOutside} from 'src/components/#common/helpers/clickOutside'
    import NftCard from 'src/components/main/marketplace-seller/components/nft-card/NftCard.svelte'
    import {isLoggedIn, userProfile} from 'src/services/auth'

    export let userId

    let marketplaceContainer
    let currentPage = 0
    let perPage = 32
    let orderBy = { "column": "created_at", "desc": true }
    let filters = [{ "column": "user_id", "value": userId }]

    $: currentPage, orderBy, filters, filter()

    function filter() {
        getItemsByFilter.reset()
        getItemsByFilter.send({ data: {
            "page": currentPage + 1,
            "perPage": perPage,
            "filters": filters,
            "orderBy": orderBy,
            "isOwner": $isLoggedIn ? $userProfile.userId === userId : false
        }})
        window.scrollTo(0, marketplaceContainer?.offsetTop)
    }

    let classDropdownOpen = false
    let sortDropdownOpen = false
    let typeDropdownOpen = false
    let selectedSort = 'Newest'
    let selectedRarity = []
    let selectedType = 'all'

    function changeSort(param) {
        sortDropdownOpen = false
        switch (param) {
            case "min":
                selectedSort = "Lowest price"
                orderBy = { "column": "additional_params->>'price'", "desc": false }
                break
            case "max":
                selectedSort = "Highest price"
                orderBy = { "column": "additional_params->>'price'", "desc": true }
                break
            case "rarity":
                selectedSort = "Rarity"
                orderBy = { "column": "rarity", "desc": true }
                break
            case "old":
                selectedSort = "Oldest"
                orderBy = { "column": "created_at", "desc": false }
                break
            default:
                selectedSort = "Newest"
                orderBy = { "column": "created_at", "desc": true }
        }
    }

    function changeRarity(rarity) {
        currentPage = 0
        if (rarity == 'all') {
            selectedRarity = []
        } else {
            if (!selectedRarity.includes(rarity)) {
                selectedRarity = [...selectedRarity, rarity]
            } else {
                selectedRarity = selectedRarity.filter(item => item !== rarity)
            }
        }
        if (selectedRarity.length) {
            if (filters.find(filter => filter.column === "rarity")) {
                for (const filter of filters) {
                    if (filter.column === "rarity") filter.value = selectedRarity
                }
            } else {
                filters.push({"column": "rarity", "value": selectedRarity})
            }
        } else {
            selectedRarity = []
            filters = filters.filter(filter => filter.column !== "rarity")
        }
        filters = filters
    }

    function changeType(type) {
        currentPage = 0

        if (selectedType != type && type != 'all') {
            if (filters.find(filter => filter.column === "type")) {
                for (const filter of filters) {
                    if (filter.column === "type") filter.value = type
                }
            } else {
                filters.push({
                    "column": "type",
                    "value": type
                })
            }
            selectedType = type
        } else {
            selectedType = 'all'
            filters = filters.filter(filter => filter.column !== "type")
        }
        filters = filters
    }
</script>

<section class="catalog" bind:this={marketplaceContainer}>
    <div class="container">
        <Alert />
        <div class="row">
            <div class="col-lg-8 col-md-6">
                <div class="dropdown type-dropdown" use:clickOutside={() => {typeDropdownOpen = false}} class:active={typeDropdownOpen}>
                    <div class="dropdown-selected">
                        <div class="need-select" on:click={() => {typeDropdownOpen = !typeDropdownOpen}}>
                            Choose a type<img src="{arrow}" class="arrow" alt="">
                        </div>
                    </div>
                    <div class="dropdown-list">
                        <label class="checkbox">
                            <input type="checkbox" on:click={() => changeType('all')} checked={selectedType === 'all'} disabled={selectedType === 'all'}>All
                        </label>
                        <label class="checkbox">
                            <input type="checkbox" on:click={() => changeType('unit')} checked={selectedType === 'unit'}>Units
                        </label>
                        <label class="checkbox">
                            <input type="checkbox" on:click={() => changeType('lootbox')} checked={selectedType === 'lootbox'}>Eggs
                        </label>
                    </div>
                </div>
                <div class="dropdown" use:clickOutside={() => {classDropdownOpen = false}} class:active={classDropdownOpen}>
                    <div class="dropdown-selected">
                        <div class="need-select" on:click={() => {classDropdownOpen = !classDropdownOpen}}>
                            Choose a rarity<img src="{arrow}" class="arrow" alt="">
                        </div>
                    </div>
                    <div class="dropdown-list">
                        <label class="checkbox">
                            <input type="checkbox" on:click={() => changeRarity('all')} checked={!selectedRarity.length} disabled={!selectedRarity.length}>
                            All
                        </label>
                        <label class="checkbox">
                            <input type="checkbox" on:click={() => changeRarity(1)} checked={selectedRarity.includes(1)}>
                            Rare
                        </label>
                        <label class="checkbox">
                            <input type="checkbox" on:click={() => changeRarity(2)} checked={selectedRarity.includes(2)}>
                            Epic
                        </label>
                        <label class="checkbox">
                            <input type="checkbox" on:click={() => changeRarity(3)} checked={selectedRarity.includes(3)}>
                            Legendary
                        </label>
                        <label class="checkbox">
                            <input type="checkbox" on:click={() => changeRarity(4)} checked={selectedRarity.includes(4)}>
                            Supreme
                        </label>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="d-flex align-items-center justify-content-end">
                    <span class="sort-by">Sort by</span>
                    <div class="dropdown sort-by-dropdown"
                        use:clickOutside={() => {sortDropdownOpen = false}}
                        class:active={sortDropdownOpen}>
                        <div class="dropdown-selected">
                            <div class="need-select" on:click={() => {sortDropdownOpen = !sortDropdownOpen}}>
                                {selectedSort}<img src="{arrow}" class="arrow" alt="">
                            </div>
                        </div>
                        <div class="dropdown-list">
                            <div class="item" on:click={() => changeSort('new')}>Newest</div>
                            <div class="item" on:click={() => changeSort('old')}>Oldest</div>
                            <div class="item" on:click={() => changeSort('rarity')}>Rarity</div>
                            <div class="item" on:click={() => changeSort('min')}>Lowest price</div>
                            <div class="item" on:click={() => changeSort('max')}>Highest price</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row nft-cards">
            {#if !$getItemsByFilter.hasValue && $getItemsByFilter.loading}
                <div class="color-white text-center">Loading...</div>
            {:else if !$getItemsByFilter.hasValue && $getItemsByFilter.error }
                <div class="color-white text-center">Something went wrong</div>
            {:else if $getItemsByFilter.value}
                {#each $getItemsByFilter?.value?.items as item}
                    <div class="col-xl-3 col-lg-4 col-6">
                        <NftCard item={item} on:changed={filter}/>
                    </div>
                {:else}
                    <div class="no-data">No data yet</div>
                {/each}
            {/if}
        </div>
        <div class="text-center">
            {#if currentPage+1 < Math.ceil($getItemsByFilter?.value?.totalCount / perPage)}
                <button class="load-more-btn" on:click={() => currentPage += 1}
                    disabled={!$getItemsByFilter.hasValue && $getItemsByFilter.loading}>
                    <img src="{loadMore}" alt="">Load more
                </button>
            {/if}
            <Pagination
                bind:currentPage={currentPage}
                totalCount={$getItemsByFilter?.value?.totalCount}
                {perPage}
                disabled={!$getItemsByFilter.hasValue && $getItemsByFilter.loading}/>
        </div>
    </div>
</section>

<style>
    .catalog {
        border-top: 2px solid #282D39;
        padding-top: 50px;
    }

    .nft-mini-img img {
        height: 100%;
        width: 100%;
        object-fit: contain;
    }

    .no-data {
        color: #b4c1cf;
        font-size: 18px;
        text-align: center;
    }

    .dropdown {
        background: #343168;
        width: 290px;
        display: inline-block;
        border-radius: 3px;
        position: relative;
        z-index: 4;
    }

    .dropdown.active {
        z-index: 5;
    }

    .type-dropdown {
        margin-right: 12px;
    }

    .dropdown.sort-by-dropdown {
        width: 180px;
    }

    .dropdown-selected {
        padding: 10px;
        font-size: 14px;
        color: #A0AEC0;
        font-weight: 300;
        position: relative;
        cursor: pointer;
        user-select: none;
    }

    .arrow {
        position: absolute;
        transform: rotate(180deg);
        right: 20px;
        top: 50%;
        margin-top: -10px;
        transition: .15s;
    }

    .dropdown.active .arrow {
        transform: rotate(0deg);
    }

    .need-select {
        padding: 16px 20px;
        height: 50px;
        margin: -10px;
    }

    .dropdown-list {
        display: none;
        padding: 20px;
        position: absolute;
        background: #343168;
        width: 100%;
        border-radius: 3px;
        margin-top: 10px;
        z-index: 2;
    }

    .dropdown.active .dropdown-list {
        display: block;
    }

    .dropdown-list .checkbox,
    .dropdown-list .item {
        font-size: 16px;
        margin-bottom: 10px;
        color: white;
        padding: 5px 0;
        display: block;
        cursor: pointer;
        user-select: none;
        transition: .25s;
    }

    .dropdown-list .checkbox:hover,
    .dropdown-list .item:hover {
        color: #cbcaca;
    }

    .dropdown-list .checkbox:last-child,
    .dropdown-list .item:last-child {
        margin-bottom: 0;
    }

    .checkbox input[type="checkbox"] {
        width: 1em;
        height: 1em;
        margin-top: 1px;
        vertical-align: top;
        margin-right: 10px;
        background: none;
        border-radius: 2px;
        border: 1px solid #A0AEC0;
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        -webkit-print-color-adjust: exact;
        color-adjust: exact;
    }

    .checkbox input[type="checkbox"]:checked {
        background-color: #FF5D1C;
        border-color: #FF5D1C;
        background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3e%3cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10l3 3l6-6'/%3e%3c/svg%3e");
    }

    .sort-by {
        font-size: 14px;
        color: #a0aec0;
        padding-right: 20px;
    }

    .nft-cards {
        margin-top: 50px;
        margin-bottom: 26px;
    }

    .load-more-btn {
        font-size: 30px;
        color: #A0AEC0;
        font-family: 'Anton', sans-serif;
        background: none;
        border: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 0 auto;
        text-transform: uppercase;
        padding: 10px 15px;
        background: rgba(160, 174, 192, 0.2);
        border-radius: 6px;
        transition: .25s;
    }

    .load-more-btn:hover {
        background: rgba(160, 174, 192, 0.3);
    }

    .load-more-btn img {
        margin-right: 10px;
    }

    .catalog :global(.pagination) {
        justify-content: center;
    }

    @media(max-width: 991px) {
        .type-dropdown {
            margin: 0 0 12px 0;
        }
    }

    @media(max-width: 767px) {
        .dropdown {
            width: 100%;
            z-index: 4;
        }

        .sort-by-dropdown {
            z-index: 3;
            margin-top: 15px;
        }

        .sort-by {
            padding-top: 10px;
        }

        .catalog {
            padding-top: 30px;
        }

        .need-select {
            padding: 14px 20px;
            height: 46px;
        }

        .nft-cards {
            margin: 30px -6px 5px;
        }

        .nft-cards .col-6 {
            padding: 0 6px;
        }

        .dropdown-list .checkbox,
        .dropdown-list .item {
            font-size: 14px;
            padding: 4px 0;
            margin-bottom: 8px;
        }
    }
</style>
